import React from 'react';
import { styled } from 'styled-components';
import { useVideoConfig } from '../../../config/VideoAppContext';
import { AspectPlaceholder } from '../Placeholder/AspectPlaceholder';
import { jsx as _jsx } from "react/jsx-runtime";
export const MediaTeaserPlaceholder = () => {
  const {
    usePreview
  } = useVideoConfig();
  return /*#__PURE__*/_jsx(Layout, {
    children: /*#__PURE__*/_jsx(AspectPlaceholder, {
      aspectRatio: 16 / 9,
      isPreview: usePreview
    })
  });
};
const Layout = styled.div.withConfig({
  displayName: "MediaTeaserPlaceholder__Layout",
  componentId: "sc-1funry0-0"
})(["margin-bottom:90px;"]);